<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { ref } from 'vue';

const { props } = usePage();

const siteInfo = ref(props.siteInformation);
</script>
<template>
    <footer class="mt-2 w-full bg-[#e6e8e9] py-2 text-white shadow-inner">
        <div class="container mx-auto flex flex-col items-center justify-between px-4 lg:px-0 md:px-0 md:flex-row max-w-7xl">
            <div class="mb-2 flex items-center gap-2 md:mb-0">
                <a href="/" class="flex items-center gap-2 text-2xl font-bold tracking-tight text-[#1a2238] md:text-3xl">
                    <template v-if="siteInfo.is_logo_image && siteInfo.logo">
                        <img :src="siteInfo.logo_image_path" alt="Logo" class="h-12 w-auto max-w-[120px] object-contain" />
                    </template>
                    <template v-else>
                        <span class="flex items-center gap-2 text-lg font-semibold tracking-tight text-[#1a2238]"> {{ siteInfo.logo }} </span>
                    </template>
                </a>
            </div>
            <div class="mb-2 text-sm text-[#1a2238] md:mb-0">© {{ new Date().getFullYear() }} {{ siteInfo.logo }}. Tüm hakları saklıdır.</div>
            <div class="flex gap-4">
                <Link href="/iletisim" class="text-[#1a2238] transition-colors hover:text-[#ff6a3d]">İletişim</Link>
                <Link href="/gizlilik" class="text-[#1a2238] transition-colors hover:text-[#ff6a3d]">Gizlilik</Link>
                <Link href="/hakkimizda" class="text-[#1a2238] transition-colors hover:text-[#ff6a3d]">Hakkımızda</Link>
            </div>
        </div>
    </footer>
</template>

<style scoped>
footer {
    font-family: 'Inter', sans-serif;
}
</style>
